export default __webpack_public_path__ + "static/media/munchen_logo.ea2f58bb.png";